const FRONTEND_TARGETS = new Set(["site", "app", "store"]);

export const isFrontendTarget = (value) => FRONTEND_TARGETS.has(String(value || "").trim().toLowerCase());

const getRuntimeTarget = () => {
  if (typeof window === "undefined") return undefined;
  return window.__RUNTIME_CONFIG__?.frontendTarget;
};

export const getFrontendTarget = (value) => {
  const requestedTarget = value || getRuntimeTarget() || process.env.REACT_APP_FRONTEND_TARGET || "site";
  const target = String(requestedTarget || "").trim().toLowerCase() || "site";
  if (!isFrontendTarget(target)) {
    throw new Error(`FRONTEND_TARGET inválido: ${target}. Use site, app ou store.`);
  }
  return target;
};

